import { render } from "./PaisList.vue?vue&type=template&id=3b58a4a6&scoped=true"
import script from "./PaisList.vue?vue&type=script&lang=js"
export * from "./PaisList.vue?vue&type=script&lang=js"

import "./PaisList.vue?vue&type=style&index=0&id=3b58a4a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b58a4a6"]])

export default __exports__